module.exports = __webpack_public_path__ + "img/banner-img.1ab722d6.jpg";